export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/topojson-client/src/identity.js
// module id = ../../../../topojson-client/src/identity.js
// module chunks = vendor